import {
  LocalUser,
  LocalUserCreateRequest,
  LocalUserUpdatePasswordRequest,
  LocalUserUpdateRequest,
} from '../../types/app/localUser.types';
import { api } from '../core/api';

export const featureIsEnabled = () =>
  api.get<boolean>(`LocalUser/FeatureIsEnabled`).then((res) => res.data);

export const getList = () => api.get<LocalUser[]>(`LocalUser/GetList`).then((res) => res.data);

export const getItem = (id: string) =>
  api.get<LocalUser>(`LocalUser/GetItem?id=${id}`).then((res) => res.data);

export const updateItem = (data: LocalUserUpdateRequest) =>
  api
    .put(
      `LocalUser/UpdateItem?id=${data.id}&name=${data.name}` +
        (data.email ? `&email=${data.email}` : ''),
    )
    .then((res) => res.data);

export const updatePassword = (data: LocalUserUpdatePasswordRequest) =>
  api
    .put(`LocalUser/UpdatePassword?id=${data.id}&password=${data.password}`)
    .then((res) => res.data);

export const createItem = (data: LocalUserCreateRequest) =>
  api
    .post(
      `LocalUser/CreateItem?id=${data.id}&name=${data.name}` +
        (data.email ? `&email=${data.email}` : '') +
        `+&password=${data.password}`,
    )
    .then((res) => res.data);

export const deleteItem = (id: string) =>
  api.delete<LocalUser>(`LocalUser/DeleteItem?id=${id}`).then();
